import { useNavigate } from "react-router-dom";
import CheckBox from "../../../../../../components/inputs/checkBox/CheckBox";
import TextWrapper from "../../../../../../components/textWrapper/TextWrapper";
import { defaultProfileImage } from "../../../../../../constants/defaultUserImage";
import styles from "./oneWinner.module.css";

const OneWinner = ({ winner, handleTogglePrize }) => {
  const userImage = winner?.userInfo?.userImage?.path;

  const navigate = useNavigate();

  const handleChange = () => {
    handleTogglePrize(winner.userId, winner.tableId, winner.hasReceivedPrize);
  };

  const handleNavigateToChat = () => {
    navigate("/dashboard/customer-support/show-users-chats", {
      state: { userName: winner?.userInfo?._id },
    });
  };

  return (
    <div
      className={
        winner?.hasReceivedPrize
          ? `${styles.container} ${styles.recievedPrize}`
          : styles.container
      }
    >
      <div className={styles.userInfoWrapper}>
        <div className={styles.userInfo}>
          <TextWrapper textStyle={"textMid"}>
            {winner?.userInfo?.name}
          </TextWrapper>
          <div className={styles.chatWrapper} onClick={handleNavigateToChat}>
            <TextWrapper textStyle={"textSmall"}>
              التحدث مع المستخدم
            </TextWrapper>
          </div>
        </div>
        <img
          alt="user"
          src={userImage ? userImage : defaultProfileImage}
          className={styles.userImage}
        />
      </div>

      <CheckBox checked={winner?.hasReceivedPrize} onChange={handleChange} />
    </div>
  );
};

export default OneWinner;
